<div style="display: flex; justify-content: flex-end;">
  <button type="button" class="btn-close" [mat-dialog-close]=""></button>
</div>
<h1 *ngIf="!isEdit" mat-dialog-title class="m-0">Nuevo Medio</h1>
<h1 *ngIf="isEdit" mat-dialog-title class="m-0">Editar Medio</h1>

<div class="modal-body-scroll">
  <form class="inputform">
    <mat-form-field appearance="outline">
      <mat-label>Nombre: </mat-label>
      <input matInput [(ngModel)]="dataSt.name" name="name" required (change)="onChangeName($event)">
    </mat-form-field>

    <mat-slide-toggle [(ngModel)]="dataSt.multipleItems" name="select1">
      Permitir múltiples elementos por sucursal
    </mat-slide-toggle>
    <!--<mat-slide-toggle [(ngModel)]="dataSt.filtroSucursales" name="select3">
      Filtro Sucursales
    </mat-slide-toggle>-->
    <mat-slide-toggle [(ngModel)]="dataSt.sucursalesVacias" name="select2">
      Permitir dejar sucursales vacías
    </mat-slide-toggle>
    <mat-slide-toggle [(ngModel)]="dataSt.segmentable" name="select3">
      Segmentable
    </mat-slide-toggle>
    <mat-slide-toggle [(ngModel)]="dataSt.multiples_promociones" name="select4">
      No repetir promociones
    </mat-slide-toggle>
    <mat-slide-toggle [(ngModel)]="dataSt.imagenes_compartidas" name="select5">
      Artes compartidos
    </mat-slide-toggle>
    <div *ngIf="mostrarAdvertenciaArtesCompartidos" class="shared-arts-warning alert alert-warning" role="alert">
      <mat-icon>warning_amber</mat-icon>
      <span>
        Si desactivas <strong>Artes compartidos</strong> cuando ya existen archivos compartidos,
        estos dejarán de utilizarse y será necesario subir un arte individual para este medio.
      </span>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Formato de Distribución</mat-label>
      <mat-select  [(ngModel)]="selectedFormato" name="formato">
        <mat-option [value]="2">Por Prioridad</mat-option>
        <mat-option [value]="1">Por Reglas</mat-option>
        <mat-option [value]="3">Por Máximos</mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field appearance="outline" hidden>
      <mat-label>Tipo de Inventario</mat-label>
      <mat-select  [(ngModel)]="selectedInventario" name="inventario">
        <mat-option [value]="'1'">Por Medio</mat-option>
        <mat-option [value]="'2'">Por POP</mat-option>
        <mat-option [value]="'3'">Por Configuración</mat-option>
        <mat-option [value]="'4'">Por Atributo</mat-option>
         <mat-option [value]="'2p'">Por POP por posición</mat-option>
      </mat-select>
    </mat-form-field>


    <div class="mb-4" *ngIf="selectedFormato == 2 || selectedFormato == 3">
      <div class="row align-items-center"> 
        <div class="col-md-4">

          <attr-autocomplete [dataSource]="numericalAtributes"
          [(selectedId)]="prioridadConf[0].id" (selectedIdChange)="setItemName($event,prioridadConf[0])"></attr-autocomplete>
          </div>
        
        <div class="col-md-3 d-flex justify-content-center">
          <span *ngIf="selectedFormato == 2" class="x-label">Multiplicado por:</span> 
          <span *ngIf="selectedFormato == 3" class="x-label">Valor a asignar:</span> 
        </div>
    
        <div class="col-md-3">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Valor</mat-label>
            <input [(ngModel)]="prioridadConf[0].multiplicador" name="multiplicadorc" matInput placeholder="Ej: 10" />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="mb-4">
      <h5 class="fw-bold text-primary">Filtro sucursales</h5>
       <p *ngIf="hasReglas && reglasAlcance.length>0 && !loadedcal"><span class="tinyfont">Calculando sucursales...</span></p>
      <p *ngIf="hasReglas && reglasAlcance.length>0 && loadedcal"><span class="tinyfont">*Cantidad de sucursales filtradas : <b>{{ sucursalesCount }}</b></span></p>
      <div *ngFor="let regla of reglasAlcance; let i = index; trackBy: trackByFn" class="mb-3">
        <div class="row">
          <div class="col-md-3">
           <!-- <mat-form-field appearance="outline" class="form-field">
              <mat-label>Atributo</mat-label>
              <mat-select [(ngModel)]="regla.id" name="atributo-{{i}}" (selectionChange)="setItemName($event.value, regla)">
                <mat-option *ngFor="let atributo of atributos" [value]="atributo.id">{{ atributo.name }}</mat-option>
              </mat-select>
            </mat-form-field>-->

            <attr-autocomplete [dataSource]="atributos"
            [(selectedId)]="regla.id" (selectedIdChange)="setItemName($event, regla)"></attr-autocomplete>

          </div>
          <div class="col-md-3">
            <mat-form-field *ngIf="getItem(regla.id) != null" appearance="outline" class="form-field">
              <mat-label>Condición</mat-label>
              <mat-select [(ngModel)]="regla.operador" name="operador-{{i}}" (selectionChange)="onOperadorChange(regla)">
                <ng-container *ngIf="getItem(regla.id) as item">
                  <mat-option *ngIf="[1, 3, 4, 5, 6].includes(item.type_id)" [value]="1">Igual que</mat-option>
                  <mat-option *ngIf="[4, 6].includes(item.type_id)" [value]="2">Mayor que</mat-option>
                  <mat-option *ngIf="[4, 6].includes(item.type_id)" [value]="3">Menor que</mat-option>
                  <mat-option *ngIf="[1, 3, 4, 5, 6].includes(item.type_id)" [value]="4">Incluye</mat-option>
                </ng-container>

              </mat-select>
            </mat-form-field>
          </div> 
          <div class="col-md-5">
            <ng-container *ngIf="getItem(regla.id) as item">
              <!-- Campo de valor para operadores que NO son "Incluy a" -->
              <mat-form-field *ngIf="regla.operador !== 4" appearance="outline" class="form-field">
                <mat-label>Valor</mat-label>
                <input matInput [hidden]="item.type_id != 4" [(ngModel)]="regla.valor" name="valor-{{i}}" (ngModelChange)="calculateStores()" type="number" placeholder="Valor de {{getRanges(item.select_data)[0]}} a {{getRanges(item.select_data)[1]}}" min="{{getRanges(item.select_data)[0]}}" max="{{getRanges(item.select_data)[1]}}">
                <input matInput [hidden]="item.type_id != 6" [(ngModel)]="regla.valor" name="valor-{{i}}" (ngModelChange)="calculateStores()" type="number"  placeholder="Ej: 10" />
                <input matInput [hidden]="item.type_id != 5" [(ngModel)]="regla.valor" name="valor-{{i}}" (ngModelChange)="calculateStores()" placeholder="Ej: Valor" />
                <ng-container *ngIf="item.type_id == 3">
                  <mat-select  [(ngModel)]="regla.valor" (selectionChange)="calculateStores()" name="valor-{{i}}">
                    <mat-option *ngFor="let valor of converToObject(item.select_data)" [value]="valor" >{{ valor }}</mat-option>
                  </mat-select>
                </ng-container>
                <ng-container *ngIf="item.type_id == 1" >
                  <mat-select  [(ngModel)]="regla.valor" name="valor-{{i}}" (selectionChange)="calculateStores()">
                    <mat-option  [value]="'SI'">SI</mat-option>
                    <mat-option  [value]="'NO'">NO</mat-option>
                  </mat-select>
                </ng-container>
              </mat-form-field>
  
              <!-- Manejo del operador "Incluye a" -->
              <ng-container *ngIf="regla.operador === 4">
                <!-- Input para añadir chips de texto/número -->
                <mat-form-field *ngIf="item.type_id !== 3" appearance="outline" class="form-field chip-list-field">
                  <mat-label>Valores (separados por coma o Enter)</mat-label>
                  <mat-chip-list #chipList aria-label="Selección de valores">
                    <mat-chip *ngFor="let chip of regla.valor" (removed)="removeChip(regla, chip)">
                      {{chip}}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input class="mat-chip-input-custom"
                           [matChipInputFor]="chipList"
                           [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                           [matChipInputAddOnBlur]="true"
                           (matChipInputTokenEnd)="addChip(regla, $event)">
                  </mat-chip-list>
                </mat-form-field>

                <!-- mat-select -->
                <mat-form-field *ngIf="item.type_id === 3" appearance="outline" class="form-field">
                  <mat-label>Valores (Incluye a)</mat-label>
                  <mat-select [(ngModel)]="regla.valor" name="valor-multiple-{{i}}" (selectionChange)="calculateStores()" multiple>
                    <mat-option *ngFor="let option of converToObject(item.select_data)" [value]="option">{{option}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
            </ng-container>
          </div> 
          <div class="col-md-1">
            <button mat-icon-button color="warn" (click)="eliminarRegla(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <button mat-flat-button color="primary" (click)="agregarRegla()">
        <mat-icon>add</mat-icon> Añadir Regla
      </button>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Descripción</mat-label>
      <textarea matInput [(ngModel)]="dataSt.descripcion" name="descripcion" rows="4" placeholder="Escribe aquí la descripción..."></textarea>
    </mat-form-field>
    
  </form>
</div>

<!-- Footer del modal -->
<div mat-dialog-actions class="button-container">
  <button mat-raised-button class="nest-button" *ngIf="!isEdit" (click)="register()" [disabled]="invalidInput()">Agregar</button>
  <button mat-raised-button class="nest-button" *ngIf="isEdit" (click)="edit()" [disabled]="invalidInput()">Guardar</button>
</div>
